import { render } from "./CourseDetailsModal.vue?vue&type=template&id=1b93f7ca&scoped=true"
import script from "./CourseDetailsModal.vue?vue&type=script&lang=js"
export * from "./CourseDetailsModal.vue?vue&type=script&lang=js"

import "./CourseDetailsModal.vue?vue&type=style&index=0&id=1b93f7ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b93f7ca"]])

export default __exports__